import Vue from "vue";
import Vuetify from "vuetify/lib";
import VueI18n from "vue-i18n";
import { messages } from "../i18n/translations";
import VuetifyConfirm from "vuetify-confirm";

import {
  COLOR_PRIMARY,
  COLOR_SECONDARY,
  COLOR_ACCENT,
  COLOR_WARNING,
  COLOR_PRIMARY_DARK,
  COLOR_SECONDARY_DARK,
  COLOR_ACCENT_DARK,
  COLOR_WARNING_DARK,
} from "../utils/colors";
import { DEFAULT_LOCALE, Language } from "@/i18n/LanguageTypes";
import { LanguageModule } from "@/store/modules/LanguageVuexModule";
import { ThemeModule } from "@/store/modules/ThemeVuexModule";

Vue.use(Vuetify);
Vue.use(VueI18n);

// TODO: Change fallback locale to English
//const fallbackLocale = "de";

/**
 * Default locale used for company settings.
 *
 * Defined in `@/i18n/LanguageTypes` and re-exported here so its existing callers keep this import
 * path, while modules that read it during initialization can take it from the leaf instead.
 */
export { DEFAULT_LOCALE };
export const FALLBACK_TO_ENGLISH = Language.ENGLISH;
export const FALLBACK_TO_GERMAN = Language.GERMAN;

export const i18n = new VueI18n({
  locale: LanguageModule.localeCache ?? DEFAULT_LOCALE,
  fallbackLocale: FALLBACK_TO_GERMAN,
  messages: messages,
});

const vuetify = new Vuetify({
  lang: {
    // Vuetify's own month and weekday names (the date pickers) follow the app's language, kept in step
    // by `changeLanguageTo`; a fixed DEFAULT_LOCALE showed German calendars in every language.
    current: i18n.locale,
    t: (key, ...params) => i18n.t(key, params).toString(),
  },
  theme: {
    dark: ThemeModule.isDark,
    // NOTE: customProperties is intentionally NOT enabled and the light palette is
    // kept to the original four slots so light mode renders exactly as before dark
    // mode was added. Dark styling is done via themed() + `.theme--dark` overrides.
    themes: {
      light: {
        primary: COLOR_PRIMARY,
        secondary: COLOR_SECONDARY,
        accent: COLOR_ACCENT,
        warning: COLOR_WARNING,
      },
      dark: {
        primary: COLOR_PRIMARY_DARK,
        secondary: COLOR_SECONDARY_DARK,
        accent: COLOR_ACCENT_DARK,
        warning: COLOR_WARNING_DARK,
      },
    },
  },
});

export default vuetify;

Vue.use(VuetifyConfirm, {
  vuetify,
  color: "primary",
});
